import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Worksheet } from '../../../types/worksheet';
import Calculations from './Calculations';
import TemplateBrowser from './TemplatesBrowser';
import PriorCalculations from './PriorCalculations';
import CimplicoStaffGuard from '../../../components/cimplico-staff-guard/CimplicoStaffGuard';

type CalculationsContainerProps = {
    worksheet: Worksheet;
    priorWorksheet?: Worksheet;
};

function CalculationsContainer({ worksheet, priorWorksheet }: CalculationsContainerProps): JSX.Element {
    const [showBrowser, setShowBrowser] = useState(false);
    const [search] = useSearchParams();
    const calculationId = search.get('calculationId');

    if (showBrowser) {
        return (
            <>
                <TemplateBrowser worksheet={worksheet} onBackClick={(): void => setShowBrowser(false)} />
            </>
        );
    }

    return (
        <>
            <Calculations worksheet={worksheet} onNewCalcClick={(): void => setShowBrowser(true)} />
            <CimplicoStaffGuard>
                {!calculationId && priorWorksheet && priorWorksheet.calculations.length > 0 && (
                    <PriorCalculations priorWorksheet={priorWorksheet} currentWorksheet={worksheet} />
                )}
            </CimplicoStaffGuard>
        </>
    );
}

export default CalculationsContainer;
